module.exports = function(){




    /*--------------------------------------------------------*\

        ephCart helpers
        (should be used only on 'lscart-' events)

    \*--------------------------------------------------------*/

    window.ephCart = {

        /*------------------------------------*\
            OPEN SIDEBAR CART
        \*------------------------------------*/
        openSidebarCart: function(){
            $('.html').addClass('is-open--dropdown');
        },


        /*------------------------------------*\
            CLOSE SIDEBAR CART
        \*------------------------------------*/
        closeSidebarCart: function(){
            $('.html').removeClass('is-open--dropdown');
            $('.html').removeClass('is-sidebar-cart-opened');
        },


        /*------------------------------------*\
            UPDATE CART BUTTON
        \*------------------------------------*/
        updateCartButton: function(){
            $('.js-cart-count').text(lsCart.getIndexCount());

            $('.js-cart-toggle').addClass('is-new-item-added');
            setTimeout(function(){
                $('.js-cart-toggle').removeClass('is-new-item-added');
            }, 500);


            // also should we show checkout button?

            if (!lsCart.getIndexCount()) {
                $('[js-cart-checkout-btn-check-visible]').hide();
            } else {
                $('[js-cart-checkout-btn-check-visible]').show();
            }


        },






        /*------------------------------------*\
            REMOVE ITEM
        \*------------------------------------*/
        removeItem: function(productId){

            var self = this;

            $('.js-cart-sidebar-dynamic').find('.js-cart-product[data-prod-id="' + productId + '"]').remove();

            if ($('.js-cart-order-dynamic').length) {
                $('.js-cart-order-dynamic').find('.js-cart-product[data-prod-id="' + productId + '"]').remove();
            }

            self.todoIfNoCartItems();
            self.updateCartButton();

        },



        /*------------------------------------*\
            REMOVE ITEM UID
        \*------------------------------------*/
        removeItemUid: function(uid){

            var self = this;

            $('.js-cart-sidebar-dynamic').find('.js-cart-product[data-cart-item-uid="' + uid + '"]').remove();

            if ($('.js-cart-order-dynamic').length) {
                $('.js-cart-order-dynamic').find('.js-cart-product[data-cart-item-uid="' + uid + '"]').remove();
            }

            self.todoIfNoCartItems();
            self.updateCartButton();

        },





        /*------------------------------------*\
            IS ALREADY IN CART?
            helper function
        \*------------------------------------*/
        itemAlreadyInCart: function(productId){

            var containerSidebar = $('.js-cart-sidebar-dynamic');
            var containerOrder = $('.js-cart-order-dynamic');

            var itemExists = containerSidebar.find('.js-cart-product[data-prod-id="' + productId + '"]').length;

            if (itemExists) {
                return true;
            } else {
                return false;
            }

        },




        /*------------------------------------*\
            LOADING INDICATOR
        \*------------------------------------*/
        loadingIndicator: function(enabled){
            var sidebar = $('.js-dropdown');

            if (enabled==true) {
                sidebar.addClass('is-loading');
            } else {
                sidebar.removeClass('is-loading');
            }

        },


        /*------------------------------------*\
            RENDER ITEM
        \*------------------------------------*/
        renderItem: function(productId, customizations, backendCartId, uid){

            var self = this;
            var itemTemplate = require('../templates/cart-item.hbs');
            var containerSidebar = $('.js-cart-sidebar-dynamic');
            var containerOrder = $('.js-cart-order-dynamic');
            //var backendCartId = backendCartId ? backendCartId : false;

            window.eph.getSingleProduct(productId, customizations, false, uid, function(templateData){


                // update: allow multiple items to be added normally
                if (false && self.itemAlreadyInCart(productId)) {
                    var itemToUpdate = containerSidebar.find('.js-cart-product[data-prod-id="' + productId + '"]');
                    itemToUpdate.replaceWith( itemTemplate(templateData) );
                }


                else {

                    containerSidebar.append( itemTemplate(templateData) );

                    // if in order page then add items also there
                    if (containerOrder.length) {
                        containerOrder.append( itemTemplate(templateData) );
                    }
                }



                var renderedItem = containerSidebar.find('.js-cart-product[data-prod-id="' + productId + '"]');
                //var renderedItemCustomizationsView = $(renderedItem).find('.js-cart-cust-view');





                //renderedItemCustomizationsView.jBox('Tooltip', {
                //    //attach: ,
                //    content: renderedItemCustomizationsContent,
                //    constructOnInit: false,
                //    trigger: 'click',
                //    fixed: false,
                //    repositionOnOpen: true,
                //    repositionOnContent: true,
                //    adjustTracker: 'scroll',
                //    closeOnMouseleave: false,
                //    animation: {
                //        open: 'move',
                //        close: 'move'
                //    },
                //    maxWidth: 280,
                //    position: {
                //        y: 'top'
                //    },
                //});



            });

            self.todoIfNoCartItems();
            self.updateCartButton();

        },




        /*------------------------------------*\
            TODO IF NO CART ITEMS
        \*------------------------------------*/
        todoIfNoCartItems: function(){
            var localItems = lsCart.getAllItems();
            var containerSidebar = $('.js-cart-sidebar-dynamic');
            var containerOrder = $('.js-cart-order-dynamic');

            if (! Object.keys(localItems).length) {
                containerSidebar.html('<div class="cart__content--no-items"><i class="cart__icon--no-items icon-eph-cart"></i><h2 class="cart__heading--no-items js-cart-no-items">Your cart is empty.</h2><a href="" class="button--primary">Start Shopping</a></div>');
                containerOrder.html('<h2 class="js-cart-no-items">No items</h2>');
                $('.js-cart-continue-shopping-btn').removeClass('is-visible');
            }
            else {
                $('.js-cart-no-items').remove();
                $('.js-cart-continue-shopping-btn').addClass('is-visible');
            }
        },



        /*------------------------------------*\
            RENDER ALL ITEMS
        \*------------------------------------*/
        renderAllItems: function(){
            var self = this;

            self.loadingIndicator(true);
            setTimeout(function() {
                self.loadingIndicator(false);
            }, 3500);

            //notice('start ephCart.renderAllitems');

            var localItems = lsCart.getAllItems();
            var containerSidebar = $('.js-cart-sidebar-dynamic');
            var containerOrder = $('.js-cart-order-dynamic');

            containerSidebar.html('');
            containerOrder.html('');

            $.each(localItems, function(index, val) {
                if (val.id) {
                    self.renderItem(val.id, val.customizations, val.backend_cart_id, val.uid);
                }
            });

            self.todoIfNoCartItems();
            self.updateCartButton();


        },






        /*------------------------------------*\
            BUTTON CHECK IF IN CART
        \*------------------------------------*/
        buttonCheckIfInCart: function(){

            var self = this;

            if (!$('.js-product-container').length) {
                return false;
            }

            var prodId = $('.js-product-customize-trigger').attr('data-webprod-id');

            if (lsCart.searchItemByID(prodId) && $('[data-is-multiple]').length === 0) {

                var isMultiple = lsCart.searchItemByID(prodId, true).length > 0

                console.log('isMultiple', isMultiple, 'adding edit customizations button')

                $('.js-product-customize-trigger').before('<button type="button" class="button--primary button--full shame__customize-and-buy js-product-customize-trigger" startover="true" data-is-multiple="' + isMultiple + '" data-webprod-id="' + prodId + '">Edit Customizations</button>')

            }


        },







    };







}; // end of module.exports




// WEBPACK FOOTER //
// ./js-source/integration/cart-eph.js